module.exports = __webpack_public_path__ + "img/www.yellowpages.com.4d970c4c.png";